import axios from 'axios';
import { AppConfig, JWT } from '../config';
import { AlertAction } from './AlertAction';
import { Translate as t } from '../config/Translate';
import { ProgramConstant } from './constants/ProgramConstant';
import { SiteConstant } from './constants/SiteConstant';

// const GetSites = (filter, append = false) => async (dispatch) => {
// 	dispatch({ type: SiteConstant.LOADING });

// 	const ret = await axios.post(`${AppConfig.GROUP_API_PATH}/site`, { type: "get", data: filter }, RT_TOKEN());

// 	if (ret.data.status === 'success') {
// 		const total_count = parseInt(ret.data.data.totalcount) || 0;
// 		const list = ret.data.data;

// 		dispatch({ type: SiteConstant.GET_SITELIST, sites: list, append });
// 		dispatch({ type: ProgramConstant.SET_SEARCHSCREEN_TITLE, title: "Sites", count: total_count });
// 	} else {
// 		dispatch(AlertAction.Error(ret.data));
// 	}

// 	dispatch({ type: SiteConstant.LOADED });
// };

const GetSites = (filter, append = false) => async (dispatch) => {
	dispatch({ type: SiteConstant.LOADING });
	try {
		const ret = await axios.post(AppConfig.API_SERVER_PATH + '/site', { type: "get", data: filter }, JWT());
		if (ret.data.status == 'success') {
			dispatch({ type: SiteConstant.GET_SITELIST, sites: ret.data.data, append });
			dispatch({ type: ProgramConstant.SET_SEARCHSCREEN_TITLE, title: "Sites", count: ret.data.data.totalcount });

		} else {
			dispatch(AlertAction.Error(ret.data));
		}
	} catch (error) {
		console.error("SiteAction.GetSites error:", error);
		dispatch(AlertAction.ErrorMsg("Failed to get sites."));
	}
	dispatch({ type: SiteConstant.LOADED });
}

const GetSiteSimples = (filter, append = false) => async (dispatch) => {
	dispatch({ type: SiteConstant.LOADING });
	try {
		const data = { type: "getsimple", data: filter };
		const ret = await axios.post(AppConfig.API_SERVER_PATH + '/site', data, JWT());

		if (ret.data.status == 'success') {
			dispatch({ type: SiteConstant.GET_SITELIST, sites: ret.data.data, append });
		} else {
			dispatch(AlertAction.Error(ret.data));
		}
	} catch (error) {
		console.error("SiteAction.GetSiteSimples error:", error);
		dispatch(AlertAction.ErrorMsg("Failed to get site simples."));
	}
	dispatch({ type: SiteConstant.LOADED });
};

const GetSearchSiteAll = async (searchCols, keyword) => {
	const data = {
		type: "get",
		data: {
			searchCols: searchCols,
			searchKey: keyword
		}
	}

	try {
		return await axios.post(AppConfig.API_SERVER_PATH + '/site', data, JWT());
	} catch (error) {
		console.error("SiteAction.GetSearchSiteAll error:", error);
		return { data: { status: 'fail', data: [] } };
	}
};

const GetFavSiteAll = (filter) => async (dispatch) => {
	dispatch({ type: SiteConstant.LOADING });
	try {
		const uData = JSON.parse(localStorage.getItem('user'));
		const data = {
			type: "get",
			data: { ...filter, match: { siteId: { '$in': uData.favoriteSites } } }
			//data : {...filter}
		}
		const ret = await axios.post(AppConfig.API_SERVER_PATH + '/site', data, JWT());
		if (ret.data.status == 'success') {
			dispatch({ type: SiteConstant.GET_FAV_SITELIST, sites: ret.data.data });
		} else {
			dispatch(AlertAction.Error(ret.data));
		}
	} catch (error) {
		console.error("SiteAction.GetFavSiteAll error:", error);
		dispatch(AlertAction.ErrorMsg("Failed to get favorite sites."));
	}
	dispatch({ type: SiteConstant.LOADED });
};

// IMP-378: 콤보 표시값(title=sitename) 기준 정렬 comparator. regime B(서버 페이지네이션)라
// 리듀서 client-sort는 부분정렬 함정 → 콤보 전용 fetch 반환부에서만 정렬.
const bySiteComboTitle = (a, b) => String(a?.title || '').localeCompare(String(b?.title || ''));

// 사이트 목록은 **caller 스코프**다(서버 getPermSimple).
//   docs/specs/site-domain-model.md §2.3 — Site 조회는 Site.companyId 기준이며,
//   장비의 조직으로 좁히지 않는다(두 조직은 독립, §2.1).
const GetSiteCombo = async () => {
	const data = { type: "combo" };
	try {
		const ret = await axios.post(AppConfig.API_SERVER_PATH + '/site', data, JWT());
		if (ret.data.status == 'success') {
			// IMP-378: 이름순 정렬 (원본 응답 배열 불변)
			return [...(ret.data.data || [])].sort(bySiteComboTitle);
		} else {
			return [];
		}
	} catch (error) {
		console.error("SiteAction.GetSiteCombo error:", error);
		return [];
	}
};

const AddSite = (site) => async (dispatch) => {
	dispatch({ type: SiteConstant.LOADING });
	try {
		const data = {
			who: JSON.parse(localStorage.getItem('user')).adminid,
			type: 'create',
			data: site,
		};

		const ret = await axios.post(AppConfig.API_SERVER_PATH + '/site', data, JWT());

		if (ret.data.status == 'success') {

			// const sub = JSON.parse(localStorage.getItem('rtUser')).sub;

			// const ddbData = {
			// 	type: 'create',
			// 	data: {
			// 		companyId: '',
			// 		customerDateOfBirth: 0,
			// 		customerForgotPasswordSessionExired: 0,
			// 		who: sub,
			// 		address: site.address,
			// 		sitename: site.sitename,
			// 		customerFirstName: customerFirstName,
			// 		emsuid: ' ',
			// 		country: site.country,
			// 		email: site.email,
			// 		scp: ''
			// 	}
			// }

			// const resposne = await axios.post(`${AppConfig.GROUP_API_PATH}/site`, ddbData, RT_TOKEN());

			// console.log(response);

			dispatch(AlertAction.Success(t('common.message.success.saved')));
			dispatch({ type: SiteConstant.ADD_SITEINFO, site: ret.data.data });
		} else {
			dispatch(AlertAction.Error(ret.data));
		}
	} catch (error) {
		console.error("SiteAction.AddSite error:", error);
		dispatch(AlertAction.Error(error));
	}
	dispatch({ type: SiteConstant.LOADED });
};

const DeleteSite = (siteid) => async (dispatch) => {
	dispatch({ type: SiteConstant.LOADING });
	try {
		const data = {
			"who": JSON.parse(localStorage.getItem("user")).adminid,
			"type": "delete"
		}
		const ret = await axios.post(AppConfig.API_SERVER_PATH + '/site/' + siteid, data, JWT());
		if (ret.data.status == 'success') {
			dispatch(AlertAction.Success(t('common.message.deleted')));
			dispatch({ type: SiteConstant.DELETE_SITE, delsiteid: siteid });
		} else {
			dispatch(AlertAction.Error(ret.data));
		}
	} catch (error) {
		console.error("SiteAction.DeleteSite error:", error);
		dispatch(AlertAction.Error(error));
	}
	dispatch({ type: SiteConstant.LOADED });
};

const UpdateSiteInfo = (siteid, siteInfo) => async (dispatch) => {

	let ok = false;
	dispatch({ type: SiteConstant.LOADING });
	try {
		const data = {
			who: JSON.parse(localStorage.getItem('user')).adminid,
			type: 'update',
			data: siteInfo,
		};

		const ret = await axios.post(AppConfig.API_SERVER_PATH + '/site/' + siteid, data, JWT());
		if (ret.data.status == 'success') {

			// const ddbData = {
			// 	type: 'update',
			// 	data: siteInfo
			// }

			// const response = await axios.post(`${AppConfig.GROUP_API_PATH}/site/${siteid}`, ddbData, RT_TOKEN());

			// if (response.data.status === 'success') {
			dispatch(AlertAction.Success(t('common.message.success.saved')));
			dispatch({ type: SiteConstant.UPDATE_SITEINFO, site: ret.data.data });
			// } else {
			// 	dispatch(AlertAction.ErrorMsg("Update Failed"));
			// }
			ok = true;
		} else {
			dispatch(AlertAction.Error(ret.data));
		}
	} catch (error) {
		console.error("SiteAction.UpdateSiteInfo error:", error);
		dispatch(AlertAction.Error(error));
	}

	dispatch({ type: SiteConstant.LOADED });
	return ok;
};

const GetSite = (_id) => async (dispatch) => {
	dispatch({ type: SiteConstant.LOADING });
	try {
		let aggregate = [];
		//aggregate.push({ '$match' : { 'siteId' :  _id } });
		aggregate.push({ '$match': { 'siteId': _id } });
		aggregate = [...aggregate, ...[
			{
				$lookup: {
					from: 'companies',
					localField: 'companyId',
					foreignField: 'companyId',
					as: 'company'
				}
			},
			{
				$addFields: {
					'company': { "$arrayElemAt": ["$company", 0] }
				}
			},
			{
				$lookup: {
					from: 'products',
					localField: 'siteId',
					foreignField: 'siteId',
					as: 'products'
				}
			},
			{
				$addFields: { 'sns' : '$products.sn' }
			},
			{
				$project: {
					'products.emsalignments' : 0,
					'products.acquisitions' : 0,
					'products.histories' : 0,
					'products.qcs' : 0,
					'products.errs' : 0
				}
			}

		]];
		const data = {
			data : {
				type: "site",
				aggregate
			}
		}
		const ret = await axios.post(AppConfig.API_SERVER_PATH + '/q', data, JWT());

		////const ret = await axios.get(AppConfig.API_SERVER_PATH + '/site/' + _id, JWT());
		// const ret = await axios.get(`${AppConfig.GROUP_API_PATH}/site/${_id}`, RT_TOKEN());

		if (ret.data.status == 'success') {
			console.log("GET_SITE : ===", ret.data.data && ret.data.data[0]);
			dispatch({ type: SiteConstant.GET_SITE, site: ret.data.data && ret.data.data[0] });
		} else {
			dispatch(AlertAction.Error(ret.data));
		}
	} catch (error) {
		console.error("SiteAction.GetSite error:", error);
		dispatch(AlertAction.ErrorMsg("Failed to get site details."));
	}
	dispatch({ type: SiteConstant.LOADED });
};

const GetSiteOld = (_id) => async (dispatch) => {
	try {
		const ret = await axios.get(AppConfig.API_SERVER_PATH + '/site/' + _id, JWT());

		if (ret.data.status == 'success') {
			dispatch({ type: SiteConstant.GET_SITE, site: ret.data.data[0] });
		} else {
			dispatch(AlertAction.Error(ret.data));
		}
	} catch (error) {
		console.error("SiteAction.GetSiteOld error:", error);
		dispatch(AlertAction.ErrorMsg("Failed to get site."));
	}
	dispatch({ type: SiteConstant.LOADED });
}

const GetSiteLocal = async (_id) => {
	try {
		const ret = await axios.get(AppConfig.API_SERVER_PATH + '/site/' + _id, JWT());
		if (ret.data.status == 'success') {
			return ret.data.data;
		}
		return null;
	} catch (error) {
		console.error("SiteAction.GetSiteLocal error:", error);
		return null;
	}
};

const GetSiteAllLocal = async (data) => {
	try {
		return await axios.post(AppConfig.API_SERVER_PATH + '/site', data, JWT());
	} catch (error) {
		console.error("SiteAction.GetSiteAllLocal error:", error);
		return { data: { status: 'fail', data: [] } };
	}
}

const ClearUpdateResult = () => (dispatch) => {
	dispatch({ type: SiteConstant.LOADING });
	dispatch({ type: SiteConstant.CLEAR_UPDATERES });
	dispatch({ type: SiteConstant.LOADED });
};

const GetInstalledProduct = async (siteId) => {
	try {
		const ret = await axios.get(AppConfig.API_SERVER_PATH + '/site/getdelcheckinfo/' + siteId, JWT());
		if (ret.data.status == "success") {
			return ret.data.data;
		} else {
			AlertAction.Error("Check Fail!");
			return [];
		}
	} catch (error) {
		console.error("SiteAction.GetInstalledProduct error:", error);
		return [];
	}
};

const GetSitesByCompanyId = async (companyId) => {
	try {
		const ret = await axios.post(AppConfig.API_SERVER_PATH + '/site', { type: 'sitesByCompanyId', data: { companyId } }, JWT());

		if (ret.data?.status === 'success')
			return ret.data.data;
		else
			return [];
	} catch (error) {
		console.error("SiteAction.GetSitesByCompanyId error:", error);
		return [];
	}
}

export const SiteAction = {
	GetSites,
	GetFavSiteAll,
	GetSiteSimples,
	GetSearchSiteAll,
	GetSiteCombo,
	GetInstalledProduct,
	AddSite,
	UpdateSiteInfo,
	DeleteSite,
	GetSite,
	GetSiteOld,
	ClearUpdateResult,
	GetSiteLocal,
	GetSiteAllLocal,
	GetSitesByCompanyId
};
